import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

import { SectionTitle } from '~/src/features/mania/styled';

export const Container = styled(WideContainer)`
    flex-direction: column;
`;

export const StepsTitle = styled(SectionTitle)`
    margin-bottom: 32px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 24px;
    }
`;

export const StepsBlock = styled.section`
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: repeat(4, auto);
    gap: 24px;
    margin-bottom: 140px;
    width: fit-content;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-template-rows: repeat(2, 1fr);
        grid-template-columns: repeat(2, auto);
        margin-bottom: 88px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 122px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 54px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: flex;
        flex-direction: column;
        margin-bottom: 58px;
    }
`;
